// extracted by mini-css-extract-plugin
module.exports = {"content":"_2oDvelBemMrYluuHfdg8n6"};